export var rgb2hex = function rgb2hex(rgb) {
  if (rgb.indexOf('#') >= 0) {
    if (rgb.length === 7) {
      return rgb;
    } else {
      throw 'You passed a badly formatted hex color: ' + rgb;
    }
  }

  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  if (rgb && rgb.length === 4) {
    return '#' + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2);
  } else {
    throw 'You passed a badly formatted rgb/a color: ' + rgb;
  }
};

export var lightenColor = function lightenColor(color, percent) {
  var hexColor = rgb2hex(color);
  var f = parseInt(hexColor.slice(1), 16);
  var t = percent < 0 ? 0 : 255;
  var p = percent < 0 ? percent * -1 : percent;
  var R = f >> 16;
  var G = f >> 8 & 0x00ff;
  var B = f & 0x0000ff;

  return '#' + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
};

export var throwIfMissing = function throwIfMissing(param) {
  throw 'Missing required argument: \'' + param + '\'.';
};

export var isEmail = function isEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export var getNumber = function getNumber(value) {
  return Number(value.replace(/([\d\.]+)\D+/, '$1'));
};
export var getUnit = function getUnit(value) {
  return value.replace(/[\d\.]+(\D+)/, '$1');
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/utils.js
// module id = 155
// module chunks = 1